/**
 * GetExclusiveContentSubscriptionsUseCase
 *
 * Loads all of the viewer's exclusive-content subscriptions from local
 * SecureStorage. Data is populated by syncSecureStorageUseCase during sync
 * (one entry per creator the viewer subscribes to).
 *
 * Used by ExclusiveContentListener to hydrate the Redux slice on auth and
 * after any storage change under the EXCLUSIVE_SUBSCRIPTIONS prefix.
 */
import { SecureStorageWebCrypto } from '@/data/storage/local/secureStorageWebCrypto';
import { SECURE_STORAGE_KEYS } from '@/domain/entities/secureStorage/secureStorageKeys';
import type { ExclusiveContentSubscriptionStorage } from '@/domain/entities/secureStorage/secureStorageEntities';
import type { ExclusiveContentSubscriptionEntity } from '@/domain/entities/exclusiveContentSubscription/exclusiveContentSubscriptionEntity';
import { ExclusiveContentSubscriptionRemapper } from '@/domain/remappers/exclusiveContentSubscription/exclusiveContentSubscriptionRemapper';

export class GetExclusiveContentSubscriptionsUseCase {
  private storage: SecureStorageWebCrypto;

  constructor(storage?: SecureStorageWebCrypto) {
    this.storage = storage ?? SecureStorageWebCrypto.getInstance();
  }

  async execute(): Promise<ExclusiveContentSubscriptionEntity[]> {
    const storageItems = await this.storage.getAllWithPrefix<ExclusiveContentSubscriptionStorage>(
      SECURE_STORAGE_KEYS.EXCLUSIVE_SUBSCRIPTIONS
    );

    return ExclusiveContentSubscriptionRemapper.fromStorageList(storageItems);
  }
}

export const createGetExclusiveContentSubscriptionsUseCase = (): GetExclusiveContentSubscriptionsUseCase => {
  return new GetExclusiveContentSubscriptionsUseCase();
};
